<template>
    <div class="home">
        <div class="hero">
            <h1 class="title">Robin CORNUT</h1>
            <p class="subtitle">Étudiant en BTS SIO option SISR</p>
        </div>
        <div class="about">
            <h2>À propos de moi</h2>
            <p>Passionné par l'informatique dans toutes ses dimensions, je suis actuellement en formation BTS SIO option SISR (Solutions d'Infrastructure, Systèmes et Réseaux). Mon intérêt s'étend aussi bien à la programmation qu'aux systèmes et réseaux, en passant par la cybersécurité. Cette polyvalence, acquise notamment grâce à mon parcours en DUT et Licence informatique, me permet d'avoir une vision globale des enjeux technologiques actuels.</p>
        </div>
        <div class="scroll-container">
            <button class="scroll-button" @click="scrollToSkills" aria-label="Défiler vers les compétences">
                <i class="fas fa-chevron-down"></i>
            </button>
        </div>
        <div class="skills">
            <h2>Compétences</h2>
            
            <div class="education-section">
                <h3 class="education-title">BTS SIO option SISR</h3>
                <div class="skills-grid">
                    <div class="skill-category">
                        <h3>Systèmes</h3>
                        <ul>
                            <li>Windows Server</li>
                            <li>Linux (Debian/Ubuntu)</li>
                            <li>Active Directory</li>
                            <li>Virtualisation (VMware)</li>
                            <li>Windows Core</li>
                        </ul>
                    </div>
                    <div class="skill-category">
                        <h3>Réseaux</h3>
                        <ul>
                            <li>TCP/IP</li>
                            <li>Equipement Cisco</li>
                            <li>VLANs / Routage</li>
                            <li>Sécurité réseau</li>
                            <li>Haute Disponibilité</li>
                        </ul>
                    </div>
                    <div class="skill-category">
                        <h3>Cybersécurité</h3>
                        <ul>
                            <li>Pare-feu (PfSense)</li>
                            <li>Analyse de vulnérabilités</li>
                            <li>Rootme</li>
                            <li>Cryptographie</li>
                            <li>HTTPS/TLS/SSL</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="education-section">
                <h3 class="education-title">DUT & Licence 3 Informatique</h3>
                <div class="skills-grid">
                    <div class="skill-category">
                        <h3>Développement</h3>
                        <ul>
                            <li>Java</li>
                            <li>Python</li>
                            <li>JavaScript / Node.js</li>
                            <li>PHP</li>
                            <li>C / C#</li>      
                        </ul>
                    </div>
                    <div class="skill-category">
                        <h3>Web & Mobile</h3>
                        <ul>
                            <li>React</li>
                            <li>Vue.js</li>
                            <li>HTML5 / CSS3</li>
                            <li>Développement Android</li>
                            <li>API REST</li>
                        </ul>
                    </div>
                    <div class="skill-category">
                        <h3>Base de données & Outils</h3>
                        <ul>
                            <li>MySQL / PostgreSQL</li>
                            <li>MongoDB</li>
                            <li>Git</li>
                            <li>Docker</li>
                            <li>Outils de gestion de projet</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'HomePage',
    methods: {
        scrollToSkills() {
            const skillsSection = document.querySelector('.skills');
            skillsSection.scrollIntoView({ behavior: 'smooth' });
        }
    }
}
</script>

<style scoped>
.home {
    color: white;
    padding: 2rem;
    max-width: 1200px;
    margin: 0 auto;
}

.hero {
    text-align: center;
    margin-bottom: 4rem;
}

.title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
    background: linear-gradient(45deg, #64B5F6, #2196F3);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    animation: titleAnimation 2s ease-in-out infinite alternate;
    background-clip: text;
}

.subtitle {
    font-size: 1.5rem;
    color: #B0BEC5;
    margin-bottom: 2rem;
}

.about {
    margin-bottom: 4rem;
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid #2196F3;
    border-radius: 10px;
    padding: 2rem;
}

.about h2 {
    color: #2196F3;
    margin-bottom: 1.5rem;
}

.about p {
    font-size: 1.1rem;
    line-height: 1.6;
    color: #B0BEC5;
}

.skills {
    margin-bottom: 4rem;
}

.skills h2 {
    color: #2196F3;
    margin-bottom: 2rem;
    text-align: center;
}

.skills-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
}

.skill-category {
    background-color: rgba(0, 0, 0, 0.7);
    border: 1px solid #2196F3;
    border-radius: 10px;
    padding: 1.5rem;
    transition: transform 0.3s ease;
    backdrop-filter: blur(5px);
}

.skill-category:hover {
    transform: translateY(-5px);
    border-color: #64B5F6;
}

.skill-category h3 {
    color: #64B5F6;
    margin-bottom: 1rem;
    text-align: center;
}

.skill-category ul {
    list-style: none;
    padding: 0;
}

.skill-category li {
    color: #B0BEC5;
    margin-bottom: 0.5rem;
    padding-left: 1.5rem;
    position: relative;
}

.skill-category li::before {
    content: "•";
    color: #2196F3;
    position: absolute;
    left: 0;
}

@keyframes titleAnimation {
    from {
        filter: hue-rotate(0deg);
    }
    to {
        filter: hue-rotate(30deg);
    }
}

@media (max-width: 768px) {
    .home {
        padding: 1rem;
    }

    .title {
        font-size: 2.5rem;
    }

    .subtitle {
        font-size: 1.2rem;
    }

    .skills-grid {
        grid-template-columns: 1fr;
    }
}

.education-section {
    margin-bottom: 3rem;
}

.education-title {
    color: #64B5F6;
    font-size: 1.8rem;
    text-align: center;
    margin-bottom: 2rem;
    padding-bottom: 1rem;
    border-bottom: 2px solid #2196F3;
}

.scroll-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: -2rem 0 4rem 0;
    position: relative;
    width: 100%;
}

.scroll-container::before,
.scroll-container::after {
    content: '';
    height: 2px;
    width: 100px;
    background: linear-gradient(to right, transparent, #2196F3, transparent);
    position: absolute;
}

.scroll-container::before {
    right: calc(50% + 40px);
}

.scroll-container::after {
    left: calc(50% + 40px);
}

.scroll-button {
    width: 50px;
    height: 50px;
    background: rgba(33, 150, 243, 0.1);
    border: 2px solid #2196F3;
    border-radius: 50%;
    color: #2196F3;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    animation: float 2s ease-in-out infinite;
    backdrop-filter: blur(5px);
    z-index: 1;
}

.scroll-button:hover {
    background: rgba(33, 150, 243, 0.2);
    transform: translateY(-5px);
    color: #64B5F6;
}

.scroll-button i {
    font-size: 1.2rem;
    animation: bounce 2s ease-in-out infinite;
}

@keyframes float {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(-10px);
    }
}

@keyframes bounce {
    0%, 100% {
        transform: translateY(0);
    }
    50% {
        transform: translateY(3px);
    }
}
</style> 